export const GET_AGENTS = "GET_AGENTS";
export const ADD_AGENT = "ADD_AGENT";
export const EDIT_AGENT = "EDIT_AGENT";
export const GET_AGENT = "GET_AGENT";
export const RESET_AGENT = "RESET_AGENT";
export const ERROR_AGENT = "ERROR_AGENT";
export const GET_ALL_AGENTS = "GET_ALL_AGENTS";
